module.exports = __webpack_public_path__ + "static/media/new-install.0313427b.jpg";